import { Outlet, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';
import BottomNav from './BottomNav';
import { useAuthStore } from '@/lib/store';

export default function MainLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const isAuth = useAuthStore((s) => !!s.user);
  const isLanding = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-orange-50/30 via-white to-white">
      <Navbar />
      <main className={`flex-1 ${isAuth ? 'pb-20 md:pb-6' : ''}`}>
        <Outlet />
      </main>
      {!isLanding && <Footer />}
      {isAuth && <BottomNav />}
    </div>
  );
}
